import { slotObjectToDataTestIds } from '@elliemae/ds-system';

export const DSFormComboboxName = 'DSCombobox';

// we are naming this with the ${component_name}_slots convention to namespace & avoid errors on duplicate exports variables in aggregators
export const FORM_COMBOBOX_SLOTS = {
  // Same as old container
  ROOT: 'root',
  INPUT_WRAPPER: 'input-wrapper',
  INPUT: 'input',
  DROPDOWN_BUTTON: 'dropdown-button',
  FAST_LIST: 'fast-list',
  SECTION_WRAPPER: 'section-wrapper',
  SECTION_LABEL: 'section-label',
  SINGLE_MENU_ITEM: 'single-menu-item',
  MULTI_MENU_ITEM: 'multi-menu-item',
  LOADING_INDICATOR: 'loading-indicator',
  SKELETON_MENU_ITEM: 'skeleton-menu-item',
} as const;

// we are naming this with the ${component_name}_data_testid convention to namespace & avoid errors on duplicate exports variables in aggregators
export const FORM_COMBOBOX_DATA_TESTID = {
  ...slotObjectToDataTestIds(DSFormComboboxName, FORM_COMBOBOX_SLOTS),
  // legacy data-testid
  CONTROLS_WRAPPER: 'combobox-controls-wrapper',
  CONTAINER: 'combobox-container',
  INPUT: 'combobox-input',
  LIST: 'combobox-menu-list',
  NO_MATCHES_FOUND: 'combobox-no-matches-found',
  SELECTED_VALUES: 'combobox-selected-values',
  DROPDOWN: 'combobox-dropdown-btn',
  OPTION: 'combobox-option',
  ALLY_SELECTED_VALUES: 'combobox-ally-selected-values',
};
